import { motion } from 'framer-motion';

/**
 * PageTransition - Ultra-smooth page transitions with elegant fade
 * Buttery smooth animations when navigating between pages
 * Respects prefers-reduced-motion via CSS/Framer Motion's built-in support
 */
function PageTransition({ children }) {
  const pageVariants = {
    initial: {
      opacity: 0,
      y: 60,
      scale: 0.95
    },
    animate: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1], // Ultra-smooth easing (Apple-like)
        staggerChildren: 0.08
      }
    },
    exit: {
      opacity: 0,
      y: -30,
      scale: 0.95,
      transition: {
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }
    },
  };

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      style={{ width: '100%' }}
    >
      {children}
    </motion.div>
  );
}

export default PageTransition;

